// Builds the copy-and-paste results text, Wordle/Connections style.
//
//   Matchset · Oct 26
//   🤍💙🤍💛
//   💜💙🤍💛
//   💜💙💚💛
//   Solved in 3 tries · 1:42
//   matchset.ca
//
// Each line is one guess (at most 4, one per heart). Each heart is a row of
// the board: the row's colour when that row was right, white when it was
// wrong. Nothing reveals the answers.

export const ROW_HEARTS = ["💜", "💙", "💚", "💛"];
export const WRONG_HEART = "🤍";

export const guessLine = (correctRows: boolean[]): string =>
  correctRows.map((ok, i) => (ok ? ROW_HEARTS[i] : WRONG_HEART)).join("");

export const shortTime = (seconds: number): string =>
  `${Math.floor(seconds / 60)}:${(seconds % 60).toString().padStart(2, "0")}`;

export const summaryLine = (won: boolean, tries: number, seconds: number): string =>
  won
    ? `Solved in ${tries} ${tries === 1 ? "try" : "tries"} · ${shortTime(seconds)}`
    : `Out of hearts · ${shortTime(seconds)}`;

export const buildShareText = (opts: {
  startDate?: string;
  guesses: boolean[][]; // one entry per submission: which rows were correct after it
  won: boolean;
  seconds: number;
}): string => {
  const { startDate, guesses, won, seconds } = opts;
  const day = startDate
    ? new Date(startDate).toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" })
    : "";
  return [
    day ? `Matchset · ${day}` : "Matchset",
    ...guesses.map(guessLine),
    summaryLine(won, guesses.length, seconds),
    "matchset.ca",
  ].join("\n");
};
